import { useTypedParams } from "react-router-typesafe-routes";

import { ClientApplicationsCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const Applications = () => {
  const { clientId } = useTypedParams(
    routes.portal.clients.client.applications,
  );
  return <ClientApplicationsCard clientId={clientId} />;
};
